module.exports = __webpack_public_path__ + "static/media/logo_nerys.8e183267.svg";